import { Box, Tooltip } from "@mui/material";
import TableRowsIcon from '@mui/icons-material/TableRows';



const DOCK_BG = "rgb(87,27,46)";
const ACTIVE_BG = "rgb(53, 112, 136)";
const DOT_COLOR = "rgb(96, 196, 106)";

const BarcodeIcon = () => (
    <svg
        width="22"
        height="22"
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
        fill="white"
    >
        <g transform="translate(42.666667, 85.333333)">
            <path d="M42.6666667 0v341.333333H0V0h42.6666667Zm85.3333333 0v341.333333H85.3333333V0H128Zm85.333333 0v341.333333H170.666667V0h42.666666Zm213.333334 0v341.333333H384V0h42.666667ZM277.333333 0v341.333333H256V0h21.333333Zm64 0v341.333333H320V0h21.333333Z" />
        </g>
    </svg>
);


const CollectionsIcon = () => (
    <svg
        width="22"
        height="22"
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
    >
        <g transform="translate(96, 96)">
            {/* Outer window */}
            <rect
                x="0"
                y="0"
                width="320"
                height="320"
                rx="12"
                stroke="white"
                strokeWidth="20"
                fill="none"
            />

            {/* Top bar */}
            <line
                x1="0"
                y1="70"
                x2="320"
                y2="70"
                stroke="white"
                strokeWidth="20"
            />

            {/* Left panel */}
            <rect
                x="28"
                y="102"
                width="110"
                height="180"
                rx="8"
                stroke="white"
                strokeWidth="20"
                fill="none"
            />

            {/* Right panel */}
            <rect
                x="182"
                y="102"
                width="110"
                height="180"
                rx="8"
                stroke="white"
                strokeWidth="20"
                fill="none"
            />
        </g>
    </svg>
);

const TABS = [
    {
        label: "Tags",
        Icon: BarcodeIcon,
    },
    {
        label: "Data",
        Icon: TableRowsIcon,
    },
    {
        label: "Collections",
        Icon: CollectionsIcon,
    },
];

export default function TruinkMobileDock({ active, setActive }) {

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: "5vh",
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                pt: 2,
                pb: 2,
                zIndex: 999,
            }}
        >
            {/* Dock rail */}
            <Box
                sx={{
                    position: "relative",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    bgcolor: DOCK_BG,
                    borderRadius: "18px",
                    height: {
                        xs: 58,
                        sm: 64,
                    },
                    px: {
                        xs: "15px",
                        sm: "20px",
                    },
                    gap: 0,
                    width: "fit-content",
                    maxWidth: "95vw",
                    boxShadow: "0 8px 28px rgba(60,10,25,0.45)",
                    overflow: "visible",
                }}
            >
                {TABS.map(({ label, Icon }, i) => {
                    const isActive = active === i;

                    return (
                        <Tooltip key={label} title={label} placement="top" arrow>
                            <Box
                                component="button"
                                onClick={() => setActive(i)}
                                aria-pressed={isActive}
                                aria-label={label}
                                sx={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "3px",
                                    width: {
                                        xs: isActive ? 62 : 54,
                                        sm: isActive ? 72 : 62,
                                    },
                                    height: {
                                        xs: isActive ? 76 : 58,
                                        sm: isActive ? 88 : 64,
                                    },
                                    top: isActive ? "-1%" : 0,
                                    borderRadius: isActive ? "16px 16px 0px 0px" : "16px",
                                    background: isActive
                                        ? `linear-gradient(to top, transparent 0%, ${ACTIVE_BG} 70%, ${ACTIVE_BG} 100%)`
                                        : "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    outline: "none",
                                    WebkitTapHighlightColor: "transparent",
                                    transition: "all 0.22s cubic-bezier(0.34,1.56,0.64,1)",
                                    flexShrink: 0,

                                    "&:hover": {
                                        backgroundColor: "transparent",
                                    },

                                    "&:hover:not([aria-pressed=true])": {
                                        bgcolor: "rgba(255,255,255,0.07)",
                                    },

                                    "&:focus-visible": {
                                        outline: "2px solid rgba(255,255,255,0.45)",
                                        outlineOffset: 2,
                                    },
                                }}
                            >
                                {/* Green active dot */}
                                {isActive && (
                                    <Box
                                        aria-hidden="true"
                                        sx={{
                                            position: "absolute",
                                            top: {
                                                xs: 6,
                                                sm: 9,
                                            },
                                            right: {
                                                xs: 7,
                                                sm: 10,
                                            },
                                            width: {
                                                xs: 6,
                                                sm: 8,
                                            },
                                            height: {
                                                xs: 6,
                                                sm: 8,
                                            },
                                            borderRadius: "50%",
                                            bgcolor: DOT_COLOR,
                                            boxShadow:
                                                "0 0 7px rgba(96,196,106,0.8)",
                                        }}
                                    />
                                )}

                                {/* Icon */}
                                <Icon
                                    sx={{
                                        fontSize: {
                                            xs: isActive ? 24 : 21,
                                            sm: isActive ? 28 : 24,
                                        },
                                        color: isActive
                                            ? "#fff"
                                            : "rgba(255,255,255,0.8)",
                                        transition:
                                            "font-size 0.22s cubic-bezier(0.34,1.56,0.64,1)",
                                    }}
                                />

                                {/* Label */}
                                <Box
                                    component="span"
                                    sx={{
                                        fontSize: {
                                            xs: isActive ? 9.5 : 9,
                                            sm: isActive ? 11 : 10.5,
                                        },
                                        fontWeight: isActive ? 600 : 500,
                                        color: isActive
                                            ? "#fff"
                                            : "rgba(255,255,255,0.65)",
                                        letterSpacing: "0.01em",
                                        whiteSpace: "nowrap",
                                        transition: "color 0.2s",
                                        userSelect: "none",
                                    }}
                                >
                                    {label}
                                </Box>
                            </Box>
                        </Tooltip>
                    );
                })}
            </Box>
        </Box>
    );
}

